import { useParams } from 'react-router-dom'

import LoadingPage from '../../../../components/LoadingPage'
import { useFriendsMeQuery } from '../../../../graphql'

import FriendsOfUser from './FriendsOfUser'
import MyFriends from './MyFriends'

const Friends = () => {
  const { userHandle } = useParams<{ userHandle: string }>()
  const { data, loading } = useFriendsMeQuery()

  if (!data || loading) {
    return <LoadingPage />
  }

  if (userHandle !== data.me?.handle) {
    return <FriendsOfUser />
  }

  return <MyFriends />
}

export default Friends
